<template>
  <div>
    <div class="qa-subtitle c-text-primary">
      <router-link :to="{ name: 'QACategory', params: { id: categoryId } }">{{ categoryName }}</router-link>
    </div>
    <div class="qa-block-title">
      {{ content }}
    </div>
    <QAContentItem
      :id="id"
      :author-id="authorId"
      :author-avatar="authorAvatar"
      :author-name="authorName"
      :content="content"
      :date="date"
      :is-edit="isOwner && !bestAnswerId"
    />
  </div>
</template>

<script>
import QAContentItem from './content-item';

export default {
  name: 'QAContentQuestion',
  components: {
    QAContentItem
  },
  props: {
    data: {
      type: Object,
      default: () => ({
        id: null,
        category: null,
        content: null,
        date: null,
        authorId: null,
        authorName: null,
        authorAvatar: null
      })
    },
    isOwner: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {};
  },
  computed: {
    id: function() {
      return this.data ? this.data.id : null;
    },
    categoryName: function() {
      let result = '';

      if (!this.data || this.data.category === null) return '';

      const categories = this.$t('categories_q_a');
      const category = categories.filter(item => item.value === this.data.category);

      if (category && category.length) result = category[0].name;

      return result;
    },
    categoryId: function() {
      return this.data ? this.data.category : null;
    },
    date: function() {
      return this.data ? this.data.date : null;
    },
    content: function() {
      return this.data ? this.data.content : null;
    },
    authorId: function() {
      return this.data ? this.data.authorId : null;
    },
    authorAvatar: function() {
      return this.data ? this.data.authorAvatar : null;
    },
    authorName: function() {
      return this.data ? this.data.authorName : null;
    },
    bestAnswerId: function() {
      return this.data ? this.data.bestAnswerId : null;
    }
  },
  methods: {}
};
</script>
